import CommentFeedManagementPage from "./comment-feed-management.page";

export default CommentFeedManagementPage;
